module.exports = __webpack_public_path__ + "static/3-24c54b9ac7833ad94096b6829374c2dd.jpg";